import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Mail } from 'lucide-react';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const requiredPermission = (location.state as any)?.requiredPermission;

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950 transition-colors duration-500">
      {/* Ambient Background Glow */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-red-400/10 dark:bg-red-900/20 blur-[120px]" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[40%] h-[40%] rounded-full bg-red-100/20 dark:bg-red-950/20 blur-[120px]" />
      </div>

      <div className="relative z-10 w-full max-w-2xl px-4 sm:px-6">
        <div className="backdrop-blur-xl bg-white/70 dark:bg-white/3 border border-slate-200 dark:border-white/8 rounded-3xl p-8 sm:p-12 shadow-[0_8px_32px_0_rgba(0,0,0,0.05)] dark:shadow-[0_8px_32px_0_rgba(0,0,0,0.3)]">
          <div className="text-center space-y-6">
            {/* Icon */}
            <div className="flex justify-center">
              <div className="w-24 h-24 rounded-2xl bg-gradient-to-tr from-red-400 to-red-600 flex items-center justify-center shadow-lg">
                <ShieldAlert className="w-12 h-12 text-white" strokeWidth={1.5} />
              </div>
            </div>

            {/* Heading */}
            <div className="space-y-2">
              <h1 className="text-4xl font-bold text-slate-900 dark:text-white">
                403
              </h1>
              <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">
                Access Forbidden
              </h2>
              <p className="text-slate-600 dark:text-slate-400 text-base max-w-md mx-auto">
                You don't have permission to access this resource.
              </p>
            </div>

            {/* Permission Detail */}
            {requiredPermission && (
              <div className="bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800/30 rounded-xl p-4 max-w-md mx-auto">
                <p className="text-sm text-red-800 dark:text-red-400 font-medium">
                  Required permission:
                </p>
                <code className="block mt-2 text-sm font-mono text-red-900 dark:text-red-300 bg-red-100 dark:bg-red-900/20 px-3 py-2 rounded-lg">
                  {requiredPermission}
                </code>
              </div>
            )}

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-slate-900 dark:bg-white text-white dark:text-slate-950 rounded-xl font-semibold hover:bg-slate-800 dark:hover:bg-slate-100 transition-all duration-300 hover:scale-105 active:scale-95"
              >
                <ArrowLeft className="w-4 h-4" />
                Go Back
              </button>

              <a
                href="mailto:support@nesterra.com?subject=Access Request"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-300 dark:border-slate-700 rounded-xl font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 transition-all duration-300 hover:scale-105 active:scale-95"
              >
                <Mail className="w-4 h-4" />
                Request Access
              </a>
            </div>

            {/* Help Text */}
            <p className="text-xs text-slate-500 dark:text-slate-400 pt-2">
              If you believe you should have access to this resource, please contact your administrator or support team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;
